// extracted by mini-css-extract-plugin
export default {"howToParticipateButtonBar":"DynamicCarousel_howToParticipateButtonBar__yC26R"};